<template>
    <div>
        <div class="title">{{this.$t('ordine_n_persone')}}</div>
        <options-carousel
            :initial-idx="this.initial_people_number_idx"
            :entries="this.people_entries"
            @onSnapToItem="this.onSnapToItem"
        />
    </div>
</template>

<script>
import OptionsCarousel from "./OptionsCarousel";

export default {
    name: "Lv2MangiaRistorante",
    components: {OptionsCarousel},
    props: ['initPeopleNumber', 'numeroPersone'],
    computed: {
        people_entries: function () {
            const peopleEntries = [];
            for (let i = 1; i <= this.numeroPersone; i++) {
                peopleEntries.push({
                    primaryText: i,
                    secondaryText: this.$tc('prenotazioni_tavolo.persona', i),
                    value: i,
                });
            }

            return peopleEntries;
        },
        initial_people_number_idx: function () {
            const idx = this.people_entries.findIndex((entry) => entry.value === this.initPeopleNumber);
            return idx !== -1 ? idx : 0;
        }
    },
    methods: {
        onSnapToItem: function (index) {
            this.$emit('onPeopleNumberChange', this.people_entries[index].value);
        }
    }
}
</script>
